import { render } from "./Register.vue?vue&type=template&id=31f1c1f6&scoped=true&lang=pug"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"

import "./Register.vue?vue&type=style&index=0&id=31f1c1f6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-31f1c1f6"

export default script